import React from "react";
import DateInput from "../../../shared/components/dateInput/DateInput";
import ResetButton from "../../../shared/components/buttons/ResetButton";

const DateFilter = ({ startDate, endDate, setStartDate, setEndDate, onReset, errorMessage }) => {
  return (
    <div className="date-filter my-4">
      <div className="d-flex gap-3">
        <DateInput label="From Date" value={startDate} onChange={setStartDate} />
        <DateInput label="To Date" value={endDate} onChange={setEndDate} />
        <ResetButton onReset={onReset} />
      </div>
      <small className="text-danger">{errorMessage}</small>
    </div>
  );
};

export default DateFilter;
